<div class="wrapper">
  @if (!companionService.companionOpen()) {
    <div class="companion-trigger" tourAnchor="kira-trigger">
      <div class="companion-trigger-button">
        <app-button
          variant="ai"
          type="button"
          rounded="true"
          [class.active]="companionService.companionOpen()"
          (click)="toggle()"
        >
          <div class="d-flex align-items-center">
            <div class="mini-blob">
              <app-blob></app-blob>
            </div>
            <span class="ms-2">KIRA</span>
          </div>
        </app-button>
      </div>
    </div>
  }
  @if (companionService.companionOpen()) {
    <div
      class="companion-wrapper ct-card"
      tourAnchor="kira-trigger"
      @companionAnimation
    >
      <div class="companion-header p-2">
        <div class="ms-2">
          <h5>KIRA</h5>
          <span>
            <span class="online-dot"></span>
            <span>Online</span>
          </span>
        </div>
        <button class="close-button" type="button" (click)="closeCompanion()">
          <fa-icon [icon]="fontawesomeService.light.times" size="lg"></fa-icon>
        </button>
      </div>
      <div
        class="companion-body p-3"
        appStickToBottom
        #messageStick="stickToBottom"
      >
        @if (companionChat.loading()) {
          <div class="companion-loader px-3" @viewLoader>
            <ng-lottie [options]="companionChat.loadingLottie"></ng-lottie>
            <span>{{
              'company-tool.snippets.companion.modals.load-job-from-pdf.analysis-in-progress'
                | transloco
            }}</span>
          </div>
        } @else if (companionChat.errorWhileAnalyzing()) {
          <div class="companion-loader px-3" @viewLoader>
            <ng-lottie [options]="companionChat.errorLottie"></ng-lottie>
            <span>{{
              'company-tool.snippets.companion.modals.load-job-from-pdf.analysis-error'
                | transloco
            }}</span>
          </div>
        } @else {
          @if (showEmptyState()) {
            <div class="kira-empty py-3" @messageAnimation>
              <div class="kira-orb" aria-hidden="true">
                <app-blob></app-blob>
              </div>

              <div class="kira-empty-text">
                <h4 class="kira-empty-title">
                  {{
                    'company-tool.snippets.companion.empty-state.title'
                      | transloco: { name: userAccount()?.firstName }
                  }}
                </h4>
                <p class="kira-empty-subtitle">
                  {{
                    'company-tool.snippets.companion.empty-state.subtitle'
                      | transloco
                  }}
                </p>
              </div>

              <div
                class="kira-suggestions"
                role="list"
                [attr.aria-label]="
                  'company-tool.snippets.companion.empty-state.suggestions.aria-label'
                    | transloco
                "
              >
                <div class="kira-suggestion-row row-1" role="listitem">
                  <div class="kira-suggestion-track">
                    @for (key of emptyStateSuggestionRows[0]; track key) {
                      <app-button
                        variant="ghost"
                        [rounded]="true"
                        htmlType="button"
                        (click)="sendEmptyStateSuggestion(key)"
                      >
                        {{ key | transloco }}
                      </app-button>
                    }
                    @for (
                      key of emptyStateSuggestionRows[0];
                      track key + '-dup'
                    ) {
                      <app-button
                        variant="ghost"
                        [rounded]="true"
                        htmlType="button"
                        (click)="sendEmptyStateSuggestion(key)"
                      >
                        {{ key | transloco }}
                      </app-button>
                    }
                  </div>
                </div>
                <div class="kira-suggestion-row row-2" role="listitem">
                  <div class="kira-suggestion-track">
                    @for (key of emptyStateSuggestionRows[1]; track key) {
                      <app-button
                        variant="ghost"
                        [rounded]="true"
                        htmlType="button"
                        (click)="sendEmptyStateSuggestion(key)"
                      >
                        {{ key | transloco }}
                      </app-button>
                    }
                    @for (
                      key of emptyStateSuggestionRows[1];
                      track key + '-dup'
                    ) {
                      <app-button
                        variant="ghost"
                        [rounded]="true"
                        htmlType="button"
                        (click)="sendEmptyStateSuggestion(key)"
                      >
                        {{ key | transloco }}
                      </app-button>
                    }
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <app-companion-chat-thread></app-companion-chat-thread>
          }
        }
        <div class="anchor"></div>
      </div>
      <div class="companion-footer">
        @if (
          !companionChat.loading() &&
          !companionChat.errorWhileAnalyzing() &&
          !companionService.promptingModalOpen() &&
          companionService.role() === CompanionRole.JOB_OFFER_CREATION
        ) {
          <div class="chat-actions-wrapper" @actionBarAnimation>
            @if (connection()?.connection; as conn) {
              <button
                class="chat-action-button"
                type="button"
                (click)="loadJobFromATSModal.open()"
              >
                <img [src]="conn.iconURL" alt="ATS Logo" />
                <span
                  [innerHTML]="
                    'company-tool.snippets.companion.actions.load-job-from-ats'
                      | transloco
                        : {
                            atsName: conn?.name,
                          }
                  "
                ></span>
              </button>
            }
            <button
              class="chat-action-button"
              type="button"
              (click)="loadJobFromTemplateModal.open()"
            >
              <fa-icon
                [icon]="fontawesomeService.light.listAlt"
                size="lg"
              ></fa-icon>
              <span
                [innerHTML]="
                  'company-tool.snippets.companion.actions.load-job-from-template'
                    | transloco
                "
              ></span>
            </button>
          </div>
        }
        <div
          class="chat-input-wrapper"
          [class.dragging]="isDragging()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div
            class="kira-input-container"
            [class.disabled]="
              companionChat.isReplying() ||
              companionService.promptingModalOpen()
            "
            [class.kira-busy]="companionChat.isKiraBusy()"
            [class.listening]="isListening()"
            [class.has-attachment]="companionChat.pendingAttachment()"
          >
            @if (isDragging() && canAttachDocument()) {
              <div class="drop-zone-overlay" aria-hidden="true" @dropZoneAnimation>
                <fa-icon
                  [icon]="fontawesomeService.light.paperClip"
                  size="lg"
                ></fa-icon>
                <span>{{
                  'company-tool.snippets.companion.input.drop-zone' | transloco
                }}</span>
              </div>
            }
            <div
              appAiBorder
              radius="calc(15px + 2px)"
              [visible]="companionChat.isKiraBusy()"
            ></div>
            @if (companionChat.pendingAttachment(); as file) {
              <div class="attachment-tag" role="status">
                <fa-icon [icon]="fontawesomeService.light.paperClip"></fa-icon>
                <span class="attachment-tag-name" [title]="file.name">{{
                  file.name
                }}</span>
                <button
                  type="button"
                  class="attachment-tag-remove"
                  [attr.aria-label]="
                    'company-tool.snippets.companion.input.attachment-remove-aria'
                      | transloco
                  "
                  (click)="companionChat.clearPendingAttachment()"
                >
                  <fa-icon [icon]="fontawesomeService.light.times"></fa-icon>
                </button>
              </div>
            }
            <textarea
              class="form-control"
              rows="4"
              [placeholder]="inputPlaceholderKey() | transloco"
              (keydown.enter)="onMessageInputEnter($event)"
              [ngModel]="companionChat.textValue()"
              (ngModelChange)="companionChat.textValue.set($event)"
              [disabled]="
                companionChat.isReplying() ||
                companionChat.errorWhileAnalyzing() ||
                companionService.promptingModalOpen()
              "
              #messageInput
            ></textarea>
            <div class="kira-input-actions">
              @if (
                companionService.role() === CompanionRole.JOB_OFFER_CREATION &&
                !companionService.promptingModalOpen()
              ) {
                <app-button
                  class="attach-button"
                  variant="ghost"
                  htmlType="button"
                  [disabled]="!canAttachDocument()"
                  [ariaLabel]="
                    'company-tool.snippets.companion.input.attachment-aria'
                      | transloco
                  "
                  [tooltip]="
                    'company-tool.snippets.companion.input.attachment-tooltip'
                      | transloco
                  "
                  (click)="openDocumentPicker()"
                >
                  <fa-icon
                    [icon]="fontawesomeService.light.paperClip"
                  ></fa-icon>
                </app-button>
              }
              <div class="kira-input-actions-spacer"></div>
              <app-button
                class="mic-button"
                variant="ghost"
                htmlType="button"
                [class.listening]="isListening()"
                [disabled]="
                  companionService.promptingModalOpen() ||
                  (!canUseVoice() && !isListening()) ||
                  !voiceSupported()
                "
                [attr.aria-pressed]="isListening()"
                [ariaLabel]="
                  (isListening()
                    ? 'company-tool.snippets.companion.input.voice-stop-aria'
                    : 'company-tool.snippets.companion.input.voice-start-aria'
                  ) | transloco
                "
                [tooltip]="
                  !voiceSupported()
                    ? ('company-tool.snippets.companion.input.voice-unsupported'
                      | transloco)
                    : undefined
                "
                (click)="toggleVoiceInput()"
              >
                @if (isListening()) {
                  <span class="voice-waveform" aria-hidden="true">
                    @for (level of waveformLevels(); track $index) {
                      <span
                        class="voice-waveform-bar"
                        [style.transform]="'scaleY(' + level + ')'"
                      ></span>
                    }
                  </span>
                } @else {
                  <fa-icon
                    [icon]="fontawesomeService.light.microphone"
                  ></fa-icon>
                }
              </app-button>
              <button
                class="send-button"
                type="button"
                [disabled]="
                  companionService.promptingModalOpen() || !canSubmitMessage()
                "
                (click)="sendMessage()"
              >
                <fa-icon [icon]="fontawesomeService.light.arrowUp"></fa-icon>
              </button>
            </div>
          </div>
        </div>
        @if (companionChat.attachmentError()) {
          <div class="kira-voice-error" role="alert">
            {{
              'company-tool.snippets.companion.input.attachment-invalid'
                | transloco
            }}
          </div>
        }
        @if (voiceError()) {
          <div class="kira-voice-error" role="alert">
            {{
              'company-tool.snippets.companion.input.voice-error' | transloco
            }}
          </div>
        }
        <input
          type="file"
          [accept]="documentFileAccept"
          hidden
          #documentInput
          (change)="onDocumentInputChange($event)"
        />
        @if (
          companionChat.textValue().length >=
          (companionChat.MAX_LENGTH_CHARACTER_LIMIT * 2) / 3
        ) {
          <div
            class="kira-input-container-counter"
            [class.overlimit]="
              companionChat.textValue().length >
              companionChat.MAX_LENGTH_CHARACTER_LIMIT
            "
          >
            {{ companionChat.textValue()?.length ?? 0 }} /
            {{ companionChat.MAX_LENGTH_CHARACTER_LIMIT }}
          </div>
        }
      </div>
    </div>
  }
</div>

<!-- Load job from ATS modal -->
@if (connection()?.connection; as conn) {
  <ct-lib-modal
    [small]="true"
    [label]="
      'company-tool.snippets.companion.modals.load-job-from-ats.label'
        | transloco
          : {
              atsName: conn.name,
            }
    "
    #loadJobFromATSModal
  >
    <div class="companion-jobs-wrapper">
      <div class="row companion-jobs-search">
        <div class="col-12 form-group form-floating">
          <input
            type="text"
            class="form-control"
            id="search-input"
            [(ngModel)]="atsJobsSearchTerm"
            [placeholder]="
              'company-tool.snippets.companion.search-input.placeholder'
                | transloco
            "
          />
          <label for="search-input">{{
            'company-tool.snippets.companion.search-input.placeholder'
              | transloco
          }}</label>
        </div>
      </div>
      <div class="row companion-jobs-list">
        @for (job of filteredATSJobs(); track job.id) {
          <ng-template
            [ngTemplateOutlet]="companionJobListItemTemplate"
            [ngTemplateOutletContext]="{ job, connection: conn }"
          ></ng-template>
        }
      </div>
    </div>
  </ct-lib-modal>
}

<!-- Load job from template modal -->
<ct-lib-modal
  [small]="true"
  [label]="
    'company-tool.snippets.companion.modals.load-job-from-template.label'
      | transloco
  "
  #loadJobFromTemplateModal
>
  <div class="companion-jobs-wrapper">
    <div class="row companion-jobs-search">
      <div class="col-12 form-group form-floating">
        <input
          type="text"
          class="form-control"
          id="search-input"
          [(ngModel)]="templateJobsSearchTerm"
          [placeholder]="
            'company-tool.snippets.companion.search-input.placeholder'
              | transloco
          "
        />
        <label for="search-input">{{
          'company-tool.snippets.companion.search-input.placeholder' | transloco
        }}</label>
      </div>
    </div>
    <div class="row companion-jobs-list">
      @for (job of filteredTemplateJobs(); track job.id) {
        <ng-template
          [ngTemplateOutlet]="companionJobListItemTemplate"
          [ngTemplateOutletContext]="{ job }"
        ></ng-template>
      } @empty {
        <div class="col-12">
          <ct-lib-info-banner type="warning">
            {{
              'company-tool.snippets.companion.modals.load-job-from-template.no-jobs'
                | transloco
            }}
          </ct-lib-info-banner>
        </div>
      }
    </div>
  </div>
</ct-lib-modal>

<!-- Companion job list item template -->
<ng-template
  #companionJobListItemTemplate
  let-job="job"
  let-connection="connection"
>
  <div class="col-12">
    <div
      class="ct-card interactive"
      (click)="
        !!connection ? onATSJobSelected(job) : onTemplateJobSelected(job)
      "
    >
      <b>{{ job.title }}</b>
      @if (!!connection) {
        <i
          [innerHTML]="
            'company-tool.snippets.companion.modals.load-job-from-ats.external-id'
              | transloco
                : {
                    atsName: connection.connection?.name,
                    id: job.remoteID,
                  }
          "
        ></i>
      }
      @if (!!job.workLocation) {
        <span>
          <fa-icon [icon]="fontawesomeService.light.mapMarkerAlt"></fa-icon>
          {{ job.workLocation?.city }}
          {{
            job.workLocation?.postalCode
              ? '(' + job.workLocation?.postalCode + ')'
              : ''
          }}
        </span>
      }
      @if (!!job.releaseDate) {
        <span>
          <fa-icon [icon]="fontawesomeService.light.calendarAlt"></fa-icon>
          {{ job.releaseDate | date: 'dd.MM.yyyy' }}
        </span>
      }
    </div>
  </div>
</ng-template>
